"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Balance = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ui = require("../../../ui");
var _ticker = require("../../../ticker");
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var StyledSmall = (0, _styledComponents.default)(_ui.Small)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.tertiaryShade;
});
var Wrapper = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.tertiary;
});
var Balance = function Balance(_ref3) {
  var ticker = _ref3.ticker,
    value = _ref3.value,
    fiatTicker = _ref3.fiatTicker,
    fiatTickerValue = _ref3.fiatTickerValue;
  var _useTranslation = (0, _reactI18next.useTranslation)('libCommon'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ui.Label, null, t('balance')), /*#__PURE__*/_react.default.createElement(Wrapper, {
    className: "d-flex align-items-center"
  }, /*#__PURE__*/_react.default.createElement(_ticker.TickerNumberFormat, {
    ticker: ticker,
    value: value
  }), " ", /*#__PURE__*/_react.default.createElement(_ticker.TickerName, {
    ticker: ticker
  }), /*#__PURE__*/_react.default.createElement(StyledSmall, {
    className: "ms-2"
  }, "(", /*#__PURE__*/_react.default.createElement(_ticker.TickerSymbol, {
    ticker: fiatTicker
  }), ' ', /*#__PURE__*/_react.default.createElement(_ticker.TickerNumberFormat, {
    ticker: fiatTicker,
    value: fiatTickerValue
  }), ")")));
};
exports.Balance = Balance;